import script from "./Project.vue?vue&type=script&setup=true&lang=js"
export * from "./Project.vue?vue&type=script&setup=true&lang=js"

import "./Project.vue?vue&type=style&index=0&id=7c64e868&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c64e868"]])

export default __exports__